import { updateActividad } from "../components/Actividad/Actividades-Api";
import { SERVER_NAME, REV_PROXY_URL } from "./Constants";

export function isEmpty(value) {
  return (
    value == null || (typeof value === "string" && value.trim().length === 0)
  );
}

export function normalizarEmail(value) {
  if (value == null) return "";
  const texto = String(value).trim();
  if (texto === "") return "";
  if (texto.includes("@")) return texto;
  return texto + "@murciaeduca.es";
}

export function validActProfe(act, user) {
  const res =
    act.profesorResponsable?.id == user.id ||
    act.profesorAcomp1?.id == user.id ||
    act.profesorAcomp2?.id == user.id;
  return res;
}

export function validActProfeComentable(act, user) {
  const res = act.valorado == false && checkComentable(act, user);
  console.log(res);
  return res;
}

export function checkComentable(actividad, user) {
  const fechaFinPasada = checkFechaPasada(actividad.fechaFin);
  const res =
    user != null &&
    actividad.profesorResponsable != null &&
    actividad.profesorResponsable.id == user.id &&
    actividad.activado == true &&
    (actividad.archivada == null || actividad.archivada == false) &&
    fechaFinPasada;
  return res;
}

export function checkFechaPasada(fechaActividad) {
  if (fechaActividad != null && fechaActividad != "") {
    const fechaDate = new Date(fechaActividad);
    const currentDate = new Date();
    return currentDate > fechaDate;
  }
  return false;
}

export function imageUrl(filename) {
  var url;
  if (isEmpty(filename)) {
    url = REV_PROXY_URL + "logo-fondo-transp.png";
  } else {
    url = SERVER_NAME + "actividades/" + filename;
  }
  return url;
}

export function userIsAdmin(userLogged) {
  return userLogged?.usuarioMobEnt?.rol?.nombre === "Administrador";
}

export function userIsProfesor(userLogged) {
  return userLogged?.usuarioMobEnt?.rol?.nombre === "Profesor";
}

export function userPuedeReservarAulas(userLogged) {
  return !isEmpty(userLogged) && (userIsAdmin(userLogged) || userIsProfesor(userLogged));
}

export function esEditable(userLogged, actividad) {
  var res = false;
  if (!isEmpty(userLogged)) {
    //Se puede editar si eres el admin y no está archivada o el profesor responsable y aún no se ha completado o archivado
    res =
      (userIsAdmin(userLogged) &&
        (actividad.archivada == false || actividad.archivada == null)) ||
      (actividad.profesorResponsable?.id == userLogged.id &&
        actividad.activado == false &&
        actividad.archivada == false);
  }
  return res;
}

export function esCerrable(userLogged, act) {
  var res = false;
  if (!isEmpty(userLogged)) {
    // para ser cerrable --> ??
  }
  return res;
}

export function esComentable(userLogged, act) {
  var res = false;
  if (!isEmpty(userLogged)) {
    // para ser comentable --> ??
  }
  return res;
}

export function fechaActualStr() {
  const current = new Date();
  const res = current.toISOString().split("T")[0];
  return res;
}

export function cursoSegunFechaActual() {
  const current = new Date();
  let res;
  if (esAntesDe1Septiembre(current)) {
    res = current.getFullYear() - 1 + "/" + current.getFullYear();
  } else {
    res = current.getFullYear() + "/" + (current.getFullYear() + 1);
  }
  return res;
}

function esAntesDe1Septiembre(fecha) {
  // Crear una fecha para el 1 de septiembre del año en curso
  let primeroDeSeptiembre = new Date(fecha.getFullYear(), 8, 1); // El mes se cuenta desde 0 (enero es 0)

  // Comparar las fechas
  return fecha < primeroDeSeptiembre;
}

export function fechaEntre(fechaAComprobarStr, fechaInicial, fechaFinal) {
  let res;
  const fechaAComprobar = new Date(fechaAComprobarStr);
  if (fechaAComprobar >= fechaInicial && fechaAComprobar <= fechaFinal) {
    res = true;
  } else {
    res = false;
  }
  return res;
}

export function fechaInicioEvaluacion(evaluacion) {
  const cursoActual = cursoSegunFechaActual();
  let res;
  if (evaluacion == 1) {
    const anyo = cursoActual.split("/")[0];
    res = new Date(anyo, 8, 1); // 1 de septiembre del curso actual
  } else if (evaluacion == 2) {
    const anyo = cursoActual.split("/")[1];
    res = new Date(anyo, 0, 1); // 1 de enero del curso actual
  } else {
    const anyo = cursoActual.split("/")[1];
    res = new Date(anyo, 3, 1); // 1 de abril del curso actual
  }
  return res;
}

export function fechaFinEvaluacion(evaluacion) {
  const cursoActual = cursoSegunFechaActual();
  let res;
  if (evaluacion == 1) {
    const anyo = cursoActual.split("/")[0];
    res = new Date(anyo, 11, 31); // 31 de diciembre del curso actual
  } else if (evaluacion == 2) {
    const anyo = cursoActual.split("/")[1];
    res = new Date(anyo, 2, 31); // 31 de marzo del curso actual
  } else {
    const anyo = cursoActual.split("/")[1];
    res = new Date(anyo, 5, 30); // 30 de junio del curso actual
  }
  return res;
}

export function evaluacionActual() {
  const current = new Date();
  let res = 0;
  if (fechaEntre(current, fechaInicioEvaluacion(1), fechaFinEvaluacion(1))) {
    res = 1;
  } else if (fechaEntre(current, fechaInicioEvaluacion(2), fechaFinEvaluacion(2))) {
    res = 2;
  } else {
    res = 3;
  }
  return res;
}

export function formatearFecha(fecha) {
  // Devuelve "" si no hay fecha o es inválida para evitar 1970/errores
  if (fecha == null || fecha === "") {
    return "";
  }

  const fechaObj = new Date(fecha);
  if (isNaN(fechaObj.getTime())) {
    return "";
  }

  // Obtiene el día, mes y año de la fecha
  let dia = fechaObj.getDate();
  let mes = fechaObj.getMonth() + 1; // Los meses comienzan desde 0, así que se suma 1
  let año = fechaObj.getFullYear();

  // Asegura que el día y el mes tengan dos dígitos
  dia = dia < 10 ? "0" + dia : dia;
  mes = mes < 10 ? "0" + mes : mes;

  // Devuelve la fecha formateada
  return dia + "-" + mes + "-" + año;
}

export function recortarTexto(texto, maxLength) {
  // Evita errores cuando texto es null/undefined y permite mostrar vacío
  const safeText = texto == null ? "" : String(texto);

  if (maxLength == null || safeText.length <= maxLength) {
    return safeText;
  }

  return safeText.substring(0, maxLength) + "...";
}
